/**
 * Card heading font value for "Platform Default": no named font, so apps draw
 * the heading in their own theme font, or the system font, at the theme size.
 *
 * The API keeps it as is and sends the heading to apps with no font name. It
 * is only valid on the heading, which is the one text style with a server
 * default font (Knockout). Sub-heading and button fonts are omitted instead.
 */
export const CARD_THEME_HEADING_PLATFORM_DEFAULT_FONT = 'platform-default';

export const isCardThemeHeadingPlatformDefaultFont = (
  value: string | null | undefined
): boolean =>
  value?.trim().toLowerCase() === CARD_THEME_HEADING_PLATFORM_DEFAULT_FONT;

/**
 * The server default heading font, Knockout. The API fills it in for an
 * omitted heading font, and each platform stores it under its own name.
 */
export const CARD_THEME_KNOCKOUT_IOS_FONT = 'Knockout-49Liteweight';
export const CARD_THEME_KNOCKOUT_ANDROID_FONT = 'knockout_49';

const CARD_THEME_KNOCKOUT_FONT_NAMES = new Set([
  CARD_THEME_KNOCKOUT_IOS_FONT.toLowerCase(),
  CARD_THEME_KNOCKOUT_ANDROID_FONT.toLowerCase(),
]);

export const isCardThemeKnockoutFont = (
  value: string | null | undefined
): boolean =>
  CARD_THEME_KNOCKOUT_FONT_NAMES.has(value?.trim().toLowerCase() ?? '');
